<template>
  <InsideContent :title="$t('APP.STATS_BUILDER.ACTIVE_INSTALLS')">
    <Card v-loading="isLoading">
      <AppChart :options="chartOptions" />
    </Card>
  </InsideContent>
</template>

<script>
import InsideContent from '@@/common/layout/InsideContent';
import Card from '@@/common/Card';
import { Insight, requestQueue } from '@/api/api';
import Color from '@/utils/color';
import chart from '@/mixins/chart';
import AppChart from '@@/common/stats/AppChart';

export default {
  name: 'DiscoveryStatsActiveInstall',

  components: {
    InsideContent,
    Card,
    AppChart,
  },

  mixins: [chart],

  props: {
    packageName: {
      type: String,
      default: '',
    },
    range: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      isLoading: true,
      chartData: {},
    };
  },

  computed: {
    series() {
      return this.chartData.series || [];
    },
    dates() {
      return this.chartData.dates || [];
    },
    chartOptions() {
      const isPersian = this.lang === 'fa';
      const dir = isPersian ? 'rtl' : 'ltr';

      return {
        chart: {
          type: 'line',
          height: 200,
        },

        legend: {
          layout: 'horizontal',
          align: 'left',
        },
        colors: Color.get(this.series.length).byStep(2, 15),
        xAxis: {
          categories: this.dates,
          title: this.$t('APPS.DASHBOARD.CHARTS.X_AXIS_TITLE'),
          tickPositions: [4, 11, 18, 25],
          labels: {},
        },
        yAxis: {
          title: {
            text: this.chartData.config?.chart_dimensions?.['y-axis']?.title,
          },
        },
        tooltip: {
          useHTML: true,
          style: {
            direction: dir,
          },
          pointFormatter() {
            const titlePostfix =
              this.series.userOptions?.data_title_postfix || '';

            return `<div>
                      <span style="color:${this.color}">\u25CF</span>
                      <span style="color:${this.color}">${this.series.name}: </span>
                      <span>${this.y}</span> <span>${titlePostfix}</span>
                    </div>`;
          },
        },
        series: this.series,
      };
    },
  },

  watch: {
    packageName() {
      this.getChartsData();
    },
    range() {
      this.updateData();
    },
  },

  methods: {
    getChartsData() {
      this.showRetry = false;
      this.isLoading = true;

      return Insight.getCharts({
        app: {},
        packageName: this.packageName,
        selectedFilters: {
          primaryType: {
            type: 'install',
            child: 'active_install',
          },
          secondaryType: [],
          range: this.range,
        },
      })
        .then(res => {
          this.chartData = res.charts.primaryChart;
        })
        .catch(({ body: { message } }) => {
          if (message) {
            this.$message.error(message);
          }
          this.showRetry = true;
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    updateData() {
      if (this.isLoading) {
        requestQueue.flush();
      }
      this.getChartsData();
    },
  },
};
</script>
